<script>
import { authComputed } from "@/state/helpers";
import { required } from "vuelidate/lib/validators";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";

/**
 * up sell Component
 */
export default {
  page: {
    title: "Slot",
  },
  data() {
    return {
      slotObj: {
        slot_name: "",
        text_reply: "",
        video_file: "",
        is_common: true,
      },
      image: "",
      submitted: false,
      isBtnLoading: false,
      isSaveAndAddNew: false,
      createError: false,
      errorMessage: "",
      fileUploadLoading: false,
    };
  },

  computed: {
    ...authComputed,
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "saveAndAddNew", "cancelSubmit"],
  mounted() {
    this.setValue();
  },
  methods: {
    setValue() {
      if (this.currentProps.isEdit) {
        this.slotObj.slot_name = this.currentProps.updateValue.slot_name;
        this.slotObj.text_reply = this.currentProps.updateValue.text_reply;
        this.slotObj.video_file = this.currentProps.updateValue.video_file;
      }
    },

    async handleSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;

      let data = {};
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        data = {
          slot_name: "slot_" + this.slotObj.slot_name,
          text_reply: this.slotObj.text_reply,
          video_file: this.slotObj.video_file,
          is_common: true,
        };
        if (!this.currentProps.isEdit) {
          await UserService.addUpdateSlot(data)
            .then(async (response) => {
              if (this.isSaveAndAddNew) {
                this.$emit("saveAndAddNew", data);
              } else {
                this.$emit("submitted", data);
              }
              this.isBtnLoading = false;
              this.submitted = false;
            })
            .catch((error) => {
              this.isBtnLoading = false;
              this.createError = true;
              errorHandler(error);
              Middleware.notification("Something went wrong !!", "success");

              if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessage = error.response.data.non_field_errors;
              } else {
                this.errorMessage = error.response.data;
              }
            });
        } else {
          UserService.addUpdateSlot(data)
            .then((response) => {
              this.$emit("submitted", data, this.currentProps.isEdit);
              this.isBtnLoading = false;
              this.submitted = false;
              Middleware.notification("Successfully updated !!", "success");
            })
            .catch((error) => {
              this.isBtnLoading = false;
              this.createError = true;
              errorHandler(error);

              if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessage = error.response.data.non_field_errors;
              } else {
                this.errorMessage = error.response.data;
              }
            });
        }
      }
    },

    saveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.handleSubmit();
    },

    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },

    async uploadFile(event, type) {
      let fileObject = event.target.files[0];
      let fileName = "";

      this.slotObj.video_file = this.randomString(5) + ".mp4";
      fileName = { file_name: this.slotObj.video_file };

      this.fileUploadLoading = true;
      await UserService.mediaFileUrlGenerate(fileName)
        .then((response) => {
          let fileUrl = response.url;
          UserService.mediaFileUpload(fileUrl, fileObject).then((res) => {
            this.fileUploadLoading = false;
            this.submitted = false;
            Middleware.notification(
              "Media file upload successful !!",
              "success"
            );
          });
        })
        .catch((error) => {
          this.fileUploadLoading = false;
          this.createError = true;
          errorHandler(error);
          Middleware.notification("Something went wrong !!", "danger");
          if (typeof error.response.data.non_field_errors == "object") {
            this.errorMessage = error.response.data.non_field_errors;
          } else {
            this.errorMessage = error.response.data;
          }
        });
    },

    randomString(length) {
      var result = "";
      var characters = "abcdefghijklmnopqrstuvwxyz";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
  },
  validations: {
    slotObj: {
      slot_name: {
        required,
      },
      text_reply: {
        required,
      },
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-md-12">
      <h4>{{ currentProps.isEdit ? "Edit" : "Add New" }} Slot</h4>
      <hr />
    </div>

    <div class="col-md-6">
      <div class="mb-3">
        <b-form-group class="mb-3" label-for="slot-input">
          <span slot="label"
            >Slot Name {{ currentProps.isEdit }}
            <span class="text-danger">*</span></span
          >
          <b-form-input
            :disabled="!currentProps.isEdit"
            id="slot-input"
            type="text"
            placeholder="slot"
            v-model="slotObj.slot_name"
            autocomplete="off"
            :class="{
              'is-invalid': submitted && $v.slotObj.slot_name.$error,
            }"
          ></b-form-input>
          <div
            v-if="submitted && $v.slotObj.slot_name.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.slotObj.slot_name.required"
              >Slot name is required.</span
            >
          </div>
        </b-form-group>
      </div>
    </div>

    <div class="col-md-12">
      <div class="mb-3">
        <label class="mb-1 mt-3 fw-medium"
          >Success Reply <span class="text-danger">*</span></label
        >
        <textarea
          class="form-control"
          :maxlength="225"
          rows="3"
          placeholder="Success reply..."
          v-model="slotObj.text_reply"
        ></textarea>
      </div>
    </div>

    <h5 class="mt-4">
      Media

      <div
        class="spinner-border spinner-border-sm"
        role="status"
        v-show="fileUploadLoading"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </h5>

    <div class="col-md-6 mt-2">
      <label for="video_file">Video File</label>
      <input
        type="file"
        class="form-control"
        placeholder="Video File"
        name="video_file"
        @change="uploadFile($event, 'video_file')"
        accept="video/*"
        :src="slotObj.video_file"
        :disabled="fileUploadLoading"
      />
      <video
        width="320"
        height="240"
        controls
        autoplay
        class="mt-3 w-100"
        v-if="currentProps.isEdit"
      >
        <source
          :src="'https://vod-lex-files.s3.amazonaws.com/' + slotObj.video_file"
        />
      </video>
    </div>
    <div class="col-md-12 mt-4">
      <b-button
        class="float-end ms-2"
        variant="outline-primary"
        type="reset"
        @click="cancelSubmit"
        :disabled="fileUploadLoading"
        >Cancel</b-button
      >
      <b-button
        v-if="this.currentProps.isEdit === false"
        class="float-end ms-2"
        variant="outline-primary"
        type="button"
        :class="{ disabled: isSaveAndAddNew === true && isBtnLoading }"
        @click="saveAndAddNew"
        :disabled="fileUploadLoading"
      >
        <i
          v-if="isSaveAndAddNew === true && isBtnLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle me-2"
        ></i>
        Save & Add</b-button
      >
      <b-button
        class="float-end"
        :disabled="fileUploadLoading"
        variant="outline-primary"
        @click="handleSubmit"
        :class="{ disabled: isSaveAndAddNew !== true && isBtnLoading }"
      >
        <i
          v-if="isSaveAndAddNew !== true && isBtnLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle me-2"
        ></i>
        {{ currentProps.isEdit ? "Update" : "Save" }}
      </b-button>
    </div>
  </div>
</template>
